<template>
    <tbody class="akg-tables">
        <tr v-if="isFirst">
            <th style="min-width: 80px;">
                <div class='akg-table-header-element mt-2'
                     v-tooltip="'A KET sorszáma.'">
                    Azonosító
                </div>
            </th>
            <th style="min-width: 80px;">
                <div class='akg-table-header-element mt-2'
                     v-tooltip="'A KET trülete.'">
                    Terület
                </div>
            </th>
        </tr>
        <tr v-if="isFirst">
            <td>
                <div class="form-group">
                    <input class="form-control form-control-sm"
                           v-bind:class="{'is-invalid': $v.ket.name.$error,
                                          'is-valid':  $v.ket.name.$dirty
                                         }"
                           v-model.trim="ket.name"
                           placeholder="ID."
                           @input="$v.ket.name.$touch()">
                    <span class="invalid-feedback"
                          v-if="!$v.ket.name.required">A KET azonosító megadása kötelező.</span>
                    <span class="invalid-feedback"
                          v-if="!$v.ket.name.numeric">A KET azonosítónak számnak kell lennie.</span>
                    <span class="invalid-feedback"
                          v-if="!$v.ket.name.maxLength">Az azonosító maximum {{ $v.ket.name.$params.maxLength.max }} karakter lehet.</span>
                </div>
            </td>
            <td>
                <div class="form-group">
                    <input class="form-control form-control-sm"
                           v-bind:class="{'is-invalid': $v.ket.area.$error || !area_is_valid,
                                          'is-valid':  $v.ket.area.$dirty && area_is_valid
                                         }"
                           v-model="ket.area"
                           placeholder="Terület"
                           @input="$v.ket.area.$touch()">
                    <span class="invalid-feedback"
                          v-if="!$v.ket.area.required">A KET területének a megadása kötelező.</span>
                    <span class="invalid-feedback"
                          v-if="!area_is_valid">A KET területének számnak kell lennie.</span>
                    <span class="invalid-feedback"
                          v-if="!$v.ket.area.maxLength">A terület maximum {{ $v.ket.area.$params.maxLength.max }} számjegyű lehet.</span>
                </div>
            </td>
        </tr>
    </tbody>
</template>
<script>
import {
  required,
  maxLength,
  numeric,
  helpers
} from "vuelidate/lib/validators";
import swal from "sweetalert2";

export default {
  props: ["ket", "isFirst"],
  data() {
    return {
      area_is_valid: true,
      form: new Form({
        field: "",
        value: "",
        ketId: ""
      })
    };
  },

  validations: {
    ket: {
      name: {
        required,
        numeric,
        maxLength: maxLength(8)
      },
      area: {
        required,
        maxLength: maxLength(8)
      }
    }
  },
  watch: {
    "ket.name": function(ketName) {
      this.save("name", ketName);
    },
    "ket.area": function(ketArea) {
      this.isFloatValue("area", ketArea);
      if (this.area_is_valid) {
        this.save("area", ketArea);
        this.$emit("updated");
      }
    }
  },
  methods: {
    isFloatValue(field, value) {
      var validatedfield = field + "_is_valid";

      if (typeof value == "string") {
        var value = value.replace(",", ".");
      }

      if (value == "" || value == null) {
        return (this[validatedfield] = true);
      }

      if (
        (Number(value) == value && value % 1 === 0) ||
        (Number(value) == value && value % 1 !== 0)
      ) {
        return (this[validatedfield] = true);
      } else {
        return (this[validatedfield] = false);
      }
    },
    save: _.debounce(
      function(field, value) {
        if (this.$v.ket[field].$invalid) {
          return;
        }

        if (field == "area") {
          if (typeof value == "string") {
            var value = value.replace(",", ".");
          }
        }

        this.form.ketId = this.ket.id;
        this.form.value = value;
        this.form.field = field;
        this.form
          .post("ajax/kets/saveKet")
          .then(function() {
            $.growl.notice({
              title: "Sikeres mentés!",
              message: "A módosítások mentése sikeresen megtörtént."
            });
          })
          .catch(e => {
            $.growl.error({
              title: "Hiba!",
              message: "A módosítások mentése nem sikrült."
            });
            swal({
              type: "error",
              title: "Hiba!",
              html: e.message,
              confirmButtonColor: "#3fa535",
              confirmButtonText: "Rendben"
            });
            this.ket[field] = "";
          });
      },

      300
    )
  }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/KetIdentificationName.vue